import cds from '@/assets/cd.json'
import dmasByCd from '@/assets/dma_by_cd.json'
import dmasByState from '@/assets/dma_by_state.json'
import states from '@/assets/state.json'
import * as types from './mutation-types'

const namespaced = true

const initialState = {
  cds: [],
  dmasByCd: [],
  dmasByState: [],
  states: []
}

const mutations = {
  [types.PUT_CDS] (state, cds) {
    state.cds = cds
  },
  [types.PUT_DMAS_BY_CD] (state, dmasByCd) {
    state.dmasByCd = dmasByCd
  },
  [types.PUT_DMAS_BY_STATE] (state, dmasByState) {
    state.dmasByState = dmasByState
  },
  [types.PUT_STATES] (state, states) {
    state.states = states
  }
}

const actions = {
  getCds: ({ commit }) => {
    commit(types.PUT_CDS, JSON.stringify(cds))
  },
  getDmasByCd: ({ commit }) => {
    commit(types.PUT_DMAS_BY_CD, JSON.stringify(dmasByCd))
  },
  getDmasByState: ({ commit }) => {
    commit(types.PUT_DMAS_BY_STATE, JSON.stringify(dmasByState))
  },
  getStates: ({ commit }) => {
    commit(types.PUT_STATES, JSON.stringify(states))
  }
}

const getters = {
  cds (state) {
    return state.cds
  },
  dmasByCd (state) {
    return state.dmasByCd
  },
  dmasByState (state) {
    return state.dmasByState
  },
  states (state) {
    return state.states
  }
}

export default {
  namespaced,
  state: initialState,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/modules/geojson.js